const board = {
    bannerCode: '000',
    noticeNo: 203901
}

export default board;